@if (showRibbon && ribbonLabel) {
  <div class="env-ribbon" [attr.data-env]="ribbonLabel" role="status" [attr.aria-label]="'Entorno: ' + ribbonLabel">
    <span class="env-ribbon__label">{{ ribbonLabel }}</span>
    @if (ribbonLabel === 'DEMO') {
      <span class="env-ribbon__hint">Solo demostración</span>
    }
  </div>
}
